import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import api from "../services/api";

interface Props {
  children: React.ReactNode;
  adminOnly?: boolean; // optional, default false
}

const ProtectedRoute: React.FC<Props> = ({ children, adminOnly = false }) => {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await api.get("/auth/me"); // backend endpoint returns logged-in user
        const user = res.data;

        if (!adminOnly || user.isAdmin) {
          setAuthorized(true);
        } else {
          setAuthorized(false);
        }
      } catch {
        setAuthorized(false);
      } finally {
        setLoading(false);
      }
    };

    checkSession();
  }, [adminOnly]);

  if (loading) return <p>Loading...</p>;

  if (!authorized) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
